import axios from 'axios'
import { getToken, removeToken } from './cookie'
import { Message } from 'element-ui'
import router from '@/router'
const baseURL = process.env.VUE_APP_BASE_URL

const service = axios.create({
  baseURL,
  timeout: 300000 // 请求超时时间
  // withCredentials: false,
  // headers: {
  //   'Cache-Control': 'no-cache'
  // }
})

// request拦截,在请求发起前搞事情
service.interceptors.request.use((config) => {
  // const url = config.url
  // if (config.method === 'get') {
  //   // url.indexOf('?') === -1 ? config.url = url + '?_=' + (new Date().getTime()) : config.url = url + '&_=' + (new Date().getTime())
  // }
  console.log(getToken(), 'getToken')
  if (getToken()) {
    config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
})

// respone拦截,获取请求数据后，搞事情
service.interceptors.response.use(
  // 正常获取数据
  response => {
    if (response.data.type === 'application/octet-stream' || response.data.type === 'application/json') {
      return response
    }
    if (response.headers['content-type'] != null && response.headers['content-type'].indexOf('vnd.ms-excel') > 0) {
      return response
    }
    if (response.data && response.data.code === 200) {
      return response.data
    } else {
      if (response.data.code === 401) {
        window.localStorage.clear()
        removeToken()
        window.location.href = response.data.url
      } else {
        Message({ type: 'error', message: response.data.message })
      }
      return Promise.reject(response)
    }
  },
  // 请求失败
  error => {
    if (error.stack.indexOf('timeout of') > -1) {
      return Promise.reject('error', 'timeout')
    } else if (error.response && error.response.data && error.response.data.code == 401) {
      window.localStorage.clear()
      removeToken()
      Message({ type: 'error', message: error.response.data.message })
      router.push('/login')
      return Promise.reject('error', error)
    }
    Message({ type: 'error', message: error })
    return Promise.reject('error', error)
  }
)

export default service
